// #region Local Imports
import { ActionConsts } from "@Definitions";
// #endregion Local Imports

// #region Interface Imports
import { IAction, IHomePage } from "@Interfaces";
import { IUserPage } from "@Interfaces/Pages/User";
import { getselectedAddressForShipping } from "./helper";
// #endregion Interface Imports

const INITIAL_STATE: IUserPage.IStateProps = {
  user: null,
  selectedAddressForShipping: null,
};

export const UserReducer = (state = INITIAL_STATE, action: IAction<any>) => {
  switch (action.type) {
    case ActionConsts.User.GetMyDetails:
      return {
        ...state,
        user: action.payload,
        selectedAddressForShipping: getselectedAddressForShipping(
          action.payload.shippingAddresses
        ),
      };
    case ActionConsts.User.setSelectedAddress:
      return {
        ...state,
        selectedAddressForShipping: action.payload,
      };

    default:
      return state;
  }
};
